var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"options":_vm.eventTypeList,"value":_vm.value,"placeholder":"Select Bhandara/Satsang","onChange":_vm.onChange},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }